import React, { useState } from "react";

import { CommonTextField } from "./index";

export const CommonPhoneInput = ({ ...props }: any) => {
  const [clicked, setClicked] = useState(false);

  if (props.values[props.id] === "" && clicked) {
    props.values[props.id] = "+49";
  }

  return (
    <CommonTextField
      {...props}
      InputProps={{
        onClick: () => setClicked(true),
      }}
    />
  );
};
